import { useAtomValue, useSetAtom } from 'jotai';
import { useEffect } from 'react';
import {
	stagedResultsCountLoadableAtom,
	updateStagedResultsCountAtom,
} from '../atoms';

/**
 * Custom hook that triggers updates to the staged results count cache
 *
 * This hook should be used in ONE parent component that manages the filter state.
 * It ensures the cache is kept up-to-date whenever the loadable state changes.
 *
 * Other components should just read from `stagedResultsCountAtom` using `useAtomValue`.
 */
export function useStagedResultsCount(): void {
	const loadable = useAtomValue(stagedResultsCountLoadableAtom);
	const updateCache = useSetAtom(updateStagedResultsCountAtom);

	useEffect(() => {
		if (loadable.state === 'hasData') {
			updateCache();
		}
	}, [updateCache, loadable]);
}
